module.exports = __webpack_public_path__ + "img/woman-normal-bg-familyroom.f4b4cc41.jpg";